import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { VehicleDirectivesModule } from "../../../../../directives/_vehicle/_vehicle.directives.module";
import { FoundationJobsModule } from "../jobs/jobs.module";
import { EngineerJobItemListComponent } from "./engineer-job-item-list.component";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    EngineerJobItemListComponent
];

const declarations: any[] = [
];

const providers: any[] = [
    
];

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        FormsModule,
        FormsDirectivesModule,
        VeriDirectivesModule,
        VehicleDirectivesModule,
        MiscDirectivesModule,
        LayoutDirectivesModule,
        CoreDirectivesModule,
        ReactiveFormsModule,
        FoundationJobsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EngineerJobItemListModule {
    constructor() {
    }
}
